/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import {
  get as getAxios,
  post as postAxios,
  put as putAxios,
  deleteCall as deleteAxios,
} from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;
const PAGE_SIZE = 10;

// const accessTokenFromLocal = "0fc0515a-d081-4b4a-83ab-7c104c2e1357";

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });
const deleteCall = (url, { accessToken, data, params }) =>
  deleteAxios(url, { accessToken, data, endPoint, params });

export default class Reports {
  static downloadReports({ pageNumber = 0, pageSize }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/tasks?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Reports.downloadReports.cancel = request.cancel;
    return request;
  }

  static searchMemberReports(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/members`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
      },
    });

    Reports.searchMemberReports.cancel = request.cancel;
    return request;
  }

  static searchFriendListReports(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/friends`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
      },
    });

    Reports.searchFriendListReports.cancel = request.cancel;
    return request;
  }

  static searchFriendDeactivateReports(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/friends/deactivated`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
      },
    });

    Reports.searchFriendDeactivateReports.cancel = request.cancel;
    return request;
  }

  static searchFriendToMemberReports(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/friends/changeToMember`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
      },
    });

    Reports.searchFriendToMemberReports.cancel = request.cancel;
    return request;
  }

  static FriendSummaryReport(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/friends/summary`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
      },
    });

    Reports.SubscriptionTrendsReport.cancel = request.cancel;
    return request;
  }

  static downloadFriendSummaryReport({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/friends/summary/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadFriendSummaryReport.cancel = request.cancel;
    return request;
  }

  static FriendChangeToMemberTrendsReport(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/friends/changeToMember/trend`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
      },
    });

    Reports.FriendChangeToMemberTrendsReport.cancel = request.cancel;
    return request;
  }

  static downloadFriendChangeToMemberTrendReport({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/friends/changeToMember/trend/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadFriendSummaryReport.cancel = request.cancel;
    return request;
  }

  static NewFriendTrendsReport(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/friends/newFriend/trend`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
      },
    });

    Reports.NewFriendTrendsReport.cancel = request.cancel;
    return request;
  }

  static downloadNewFriendTrendReport({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/friends/newFriend/trend/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadNewFriendTrendReport.cancel = request.cancel;
    return request;
  }

  // NEW: Friend to Member Growth report API functions
  static FriendToMemberGrowthReport(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/friends/friendToMember/growth`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
      },
    });

    Reports.FriendToMemberGrowthReport.cancel = request.cancel;
    return request;
  }

  static searchFriendAgeingReports(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/friends/ageing`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
      },
    });

    Reports.searchFriendAgeingReports.cancel = request.cancel;
    return request;
  }

  static downloadFriendAgeingReport({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/friends/ageing/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadFriendAgeingReport.cancel = request.cancel;
    return request;
  }

  static downloadMembersReport({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/members/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadMembersReport.cancel = request.cancel;
    return request;
  }

  static downloadFriendsReport({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/friends/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadFriendsReport.cancel = request.cancel;
    return request;
  }

  static downloadFriendsDeactivateReport({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/friends/deactivated/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadFriendsDeactivateReport.cancel = request.cancel;
    return request;
  }

  static downloadFriendsChangeToMember({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/friends/changeToMember/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadFriendsDeactivateReport.cancel = request.cancel;
    return request;
  }

  static getDownlaodReportLink(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/tasks/${data}/resultUrl`, {
      accessToken: accessTokenFromLocal,
    });

    Reports.getDownlaodReportLink.cancel = request.cancel;
    return request;
  }

  static memberwiseAttendanceReports(data) {
    // console.log(data);
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/members/attendance`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
      },
    });

    Reports.memberwiseAttendanceReports.cancel = request.cancel;
    return request;
  }

  static downloadMemberwiseAttendanceReports({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/members/attendance/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadMemberwiseAttendanceReports.cancel = request.cancel;
    return request;
  }

  static downloadUnmarkedAttendance({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/attendance/notMarked/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadUnmarkedAttendance.cancel = request.cancel;
    return request;
  }

  static GohonzonAllotmentReports(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/gohonzons/allotment`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
      },
    });

    Reports.GohonzonAllotmentReports.cancel = request.cancel;
    return request;
  }

  static downloadGohonzonAllotmentReports({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/gohonzons/allotment`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadGohonzonAllotmentReports.cancel = request.cancel;
    return request;
  }

  static GohonzonConferralReports(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/gohonzons/conferral`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
      },
    });

    Reports.GohonzonConferralReports.cancel = request.cancel;
    return request;
  }

  static downloadGohonzonConferralReports({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/gohonzons/conferral`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadGohonzonConferralReports.cancel = request.cancel;
    return request;
  }

  static structureAttendanceReports(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/attendance/statistics`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
      },
    });

    Reports.structureAttendanceReports.cancel = request.cancel;
    return request;
  }

  static UnMarkedAttendanceReports(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/attendance/notMarked`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
      },
    });

    Reports.UnMarkedAttendanceReports.cancel = request.cancel;
    return request;
  }

  static transferLeaderNotAppointedReport(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/reports/appointment/transfer-leader-not-appointed`,
      {
        accessToken: accessTokenFromLocal,
        data: {
          ...data,
          pageNumber: data.pageNumber,
          pageSize: data.pageSize,
        },
      }
    );

    Reports.transferLeaderNotAppointedReport.cancel = request.cancel;
    return request;
  }

  static downloadTransferLeaderNotAppointedReport({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(
      `/api/reports/appointment/transfer-leader-not-appointed/download`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Reports.downloadTransferLeaderNotAppointedReport.cancel = request.cancel;
    return request;
  }

  static GetStatsReports(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/statistics/connections`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        // pageNumber: data?.pageNumber ?? 0,
        // pageSize: data?.pageSize ?? PAGE_SIZE,
      },
    });

    Reports.GetStatsReports.cancel = request.cancel;
    return request;
  }

  static downloadConnectionStatsReport({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/statistics/connections/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadConnectionStatsReport.cancel = request.cancel;
    return request;
  }

  static SubscriptionSearchReport(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/subscriptions`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: data?.pageNumber ?? 0,
        pageSize: data?.pageSize ?? PAGE_SIZE,
      },
    });

    Reports.SubscriptionSearchReport.cancel = request.cancel;
    return request;
  }

  static SubscriptionTrendsReport(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/subscriptions/trend`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        // pageNumber: data?.pageNumber ?? 0,
        // pageSize: data?.pageSize ?? PAGE_SIZE,
      },
    });

    Reports.SubscriptionTrendsReport.cancel = request.cancel;
    return request;
  }

  static SubscriptionMisReport(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/subscriptions/mis`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        // pageNumber: data?.pageNumber ?? 0,
        // pageSize: data?.pageSize ?? PAGE_SIZE,
      },
    });

    Reports.SubscriptionMisReport.cancel = request.cancel;
    return request;
  }

  static downloadSubscriptionTrendsReports({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/subscriptions/trend/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadSubscriptionTrendsReports.cancel = request.cancel;
    return request;
  }

  static downloadSubscriptionMisReports({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/subscriptions/mis/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadSubscriptionMisReports.cancel = request.cancel;
    return request;
  }

  static ExpiredSubscriptionSearchReport(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/subscriptions/expired`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: data?.pageNumber ?? 0,
        pageSize: data?.pageSize ?? PAGE_SIZE,
      },
    });

    Reports.ExpiredSubscriptionSearchReport.cancel = request.cancel;
    return request;
  }

  static NearToExpirySubscriptionSearchReport(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/subscriptions/nearToExpiry`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: data?.pageNumber ?? 0,
        pageSize: data?.pageSize ?? PAGE_SIZE,
      },
    });

    Reports.NearToExpirySubscriptionSearchReport.cancel = request.cancel;
    return request;
  }

  static downloadExpiredSubscriptionReports({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/subscriptions/expired/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadExpiredSubscriptionReports.cancel = request.cancel;
    return request;
  }

  static downloadNearToExpirySubscriptionReports({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/subscriptions/nearToExpiry/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadNearToExpirySubscriptionReports.cancel = request.cancel;
    return request;
  }

  static downloadSubscriptionReports({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/subscriptions/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Reports.downloadSubscriptionReports.cancel = request.cancel;
    return request;
  }
}
